/**
 * Thin wrapper around GA4 gtag for conversion/engagement events.
 *
 * Safe to call anywhere: no-ops when gtag hasn't loaded (dev without
 * NEXT_PUBLIC_GA_ID, ad blockers, or before the script initializes).
 */

type GtagWindow = Window & {
  gtag?: (...args: unknown[]) => void;
};

/** Fires a GA4 event if gtag is available. */
export function trackEvent(name: string, params?: Record<string, unknown>): void {
  if (typeof window === "undefined") return;
  const gtag = (window as GtagWindow).gtag;
  if (typeof gtag !== "function") return;
  try {
    gtag("event", name, params);
  } catch {
    // Analytics must never break UX — swallow unexpected gtag failures.
  }
}
